import { ff } from '@atlassian/jira-feature-flagging';

export const isBehaviourCommonForAllFieldsInNewGic = () =>
	ff('common-field-behaviour-for-new-gic_q9mgt', false);
